import {
  ACCEPTED,
  CANCELED,
  DECLINED,
  TIMEOUT,
} from '@rsos/constants/alertStatuses';

/**
 * Determines the visibility of alert actions such as accpet, decline, and remove alert.
 * @param {String} alertStatus - The alert status.
 * @returns Boolean
 */
export const shouldShowAlertActions = alertStatus => {
  return alertStatus !== ACCEPTED;
};

/**
 * Determines the visibility of the remove alert button.
 * @param {String} alertStatus - The alert status.
 * @param {*} isSupplementalOnly - Is the alert supplemental only?
 * @returns Boolean
 */
export const shouldShowRemoveAlert = (alertStatus, isSupplementalOnly) => {
  return (
    isSupplementalOnly || [CANCELED, DECLINED, TIMEOUT].includes(alertStatus)
  );
};
